import request from './request.js'

export default{

    //单个添加员工
    addStaffInfo(params) {
      return request({
        url: '/TBEmployee/Add',  //对象传参 code: 200 success  100 fail
        method: 'post',
        data: params,
      });
    },
    //判断员工工号是否存在
    judgeStaffJobNumber(params) {
      return request({
        //拼接参数 ：  jobNumber 员工工号
        url: '/TBEmployee/ExistsJobNumber'+ params,
        method: 'get',
      });
    },
    //判断登录账号是否存在
    judgeStaffUserName(params) {
      return request({
        //拼接参数 ：  userName 登录账号
        url: '/TBEmployee/ExistsUserName'+ params,
        method: 'get',
      });
    },
    //更新单个员工信息
    updateStaffInfo(params) {
      return request({
        url: '/TBEmployee/Set',  //对象传参 code: 200 success  100 fail
        method: 'post',
        data: params,
      });
    },
    //批量添加员工
    batchaddStaffInfo(params) {
      return request({
        url: '/TBEmployee/AddRange',  //对象传参 code: 200 success
        method: 'post',
        data: params,
      });
    },
    //员工账号解锁
    UnlockPassword(params) {
      return request({
        //拼接参数 ： jobNumber 操作员工工号  unlockJobNumber 被解锁员工工号
        url: '/TBEmployee/Unlock' + params,  // code: 200 success  100 fail
        method: 'post',
      });
    },
    //查询所有员工信息
    getStaffList(params) {
      return request({
        //拼接参数 ：  flag：不传参数查全部  0未知  1在职（默认查询在职） 2离职（默认查询在职） 3删除
        url: '/TBEmployee/GetAll'+ params,  // code: 200 success
        method: 'get',
      });
    },
    //查询单个员工信息
    getSingleStaffInfo(params){
      return request({
        //拼接参数 ： jobNumber 员工工号
        url: '/TBEmployee/Get'+ params,   // code: 200 success
        method: 'get',
      });
    }
}
